
import en from './en.json';
import es from './es.json';
import jp from './jp.json';

export const dictionaryList = { en, es, jp };

export const languageOptions = {
  en: 'English',
  es: 'Español',
  jp: '日本語'
};